import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-aviso-privacidad',
  templateUrl: './aviso-privacidad.component.html',
  styleUrls: ['./aviso-privacidad.component.css']
})
export class AvisoPrivacidadComponent implements OnInit {

  public chkAcuerdo: boolean;
  public tipo:string= '0';
  //constructor(private router: Router) { }
  constructor(private router: Router) {
    let url = this.router.routerState.snapshot.url;

    if (url === '/aviso-privacidad/1') {
      //Carga información guardada
      this.tipo = '1';

    } else if (url === '/aviso-privacidad') {
      this.tipo = '0';
    }
  }
  ngOnInit() {
  }


}
